import { Component, inject, ViewEncapsulation } from '@angular/core'
import { VSPDoctor_Type } from 'src/app/shared/services/ppv.api'
import { VetSchedulePlannerService } from '../vet-schedule-planner.service'
import { utc } from '@date-fns/utc'
import { ToastrService } from 'ngx-toastr'
import * as EnumHelper from '../enum-helper'

@Component({
   selector: 'vsp-doctor-info-dialog',
   standalone: false,
   templateUrl: './doctor-info-dialog.component.html',
   styleUrl: './doctor-info-dialog.component.scss',
   encapsulation: ViewEncapsulation.None,
})
export class DoctorInfoDialogComponent {
   service = inject(VetSchedulePlannerService)
   doctorTypes = EnumHelper.enumToValueLabelArray(EnumHelper.doctorTypes)
   VSPDoctor_Type = VSPDoctor_Type

   constructor(private toastr: ToastrService) {}

   save() {
      this.service.saveDoctorChanges().subscribe({
         next: () => {
            this.service.reloadWeek()
            this.service.doctorInfoDialogVisible.set(false)
            this.toastr.success('Doctor information saved successfully.')
         },
         error: () => {
            this.service.isLoading.set(false)
            this.service.showError('Failed to save doctor information.');
         },
      })
   }

   cancel() {
      this.service.doctorInfoDialogVisible.set(false)
   }
}
